export class AccountAssociationCountReply {
    count: number;

    constructor() {
        this.count = 0;
    }
}